<template>
  <div class="scene-game-over">
    <div class="step1" v-show="step == 1" @click="onClick">
      <img class="circle" src="/images/game/circle.png" />
      <img class="title" src="/images/game/fight-success.png" />
      <img class="wine" src="/images/game/装酒.gif" />
      <div class="tip">葡萄酒装满后就可为小悦解除封印</div>
    </div>

    <div class="step2" v-show="step == 2" @click="onClick">
      <img class="title" src="/images/game/gameover-title.png" />
      <img class="left" src="/images/game/left.png" />
      <img class="sprite" src="/images/game/sprite-5.png" />
      <img class="right" src="/images/game/right.png" />
    </div>

    <div class="step3" v-show="step == 3" @click="onClick">
      <div class="dialog">
        <div class="content">
          <TypingText :text="content" />
        </div>
      </div>
      <img class="sprite" src="/images/game/sprite-5.png" />
    </div>

    <div class="step4" v-show="step >= 4" @click="onClick">
      <div class="dialog">
        <div class="content">
          <TypingText :text="content" />
        </div>
      </div>
      <img class="sprite" src="/images/game/sprite-5.png" />
      <div class="card-parent">
        <div class="tip1">恭喜获得礼品卡：</div>
        <img class="card" src="/images/game/card.png" alt />
        <div class="tip2">可凭此礼品卡去门店兑换相应礼品</div>
      </div>
    </div>

    <BackButton @back="onBack" />
  </div>
</template>

<script>
import BackButton from "../common/BackButton";
import TypingText from "../common/TypingText";

export default {
  name: "CheckpointGameOver",
  components: {
    BackButton,
    TypingText
  },
  data() {
    return {
      step: 1,
      content: "Hello, world!"
    };
  },
  computed: {
    content1: function() {
      return `亲爱的${this.$store.state.sys.sysUser.me.nickName}真是咏悦汇超级无敌智慧使者!通过你的帮助，小悦获得了葡萄 酒精灵力量!你看小葡萄们都很高兴呢!`;
    },
    content2: function() {
      return `这是小悦感谢${this.$store.state.sys.sysUser.me.nickName}的通关礼物，已放至你的礼品卡中，请去线下门店询问可爱的工作人员兑换!`;
    },
    content3: function() {
      return `亲爱的${this.$store.state.sys.sysUser.me.nickName}，小悦和小葡萄们会很想你，请常回来看看噢，可以重新挑战关卡，获得更多关卡神秘礼物!`;
    }
  },
  created() {
    
  },
  methods: {
    onClick() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.step = this.step + 1;

      console.log(this.step);

      switch (this.step) {
        case 1:
          this.content = "1";
          break;
        case 2:
          this.content = "2";
          break;
        case 3:
          this.content = this.content1;

          console.log(this.content);
          break;
        case 4:
          this.content = this.content2;

          console.log(this.content);
          break;
        case 5:
          this.content = this.content3;
          console.log(this.content);
          break;
      }
    },
    onBack() {
      this.$emit("changeForegroundMusic", "/music/点击按钮反馈音乐.mp3");
      this.$emit("changeScene", "MainScene");
    }
  }
};
</script>


<style lang="scss" scoped>
.scene-game-over {
  width: 1100px;
  height: 560px;
  position: relative;

  background-image: url("/images/game/result-background.png");
  background-size: cover;

  .step1 {
    @keyframes circle-ani {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }

    @keyframes rotate {
      from {
        transform: rotate(0deg);
      }
      to {
        transform: rotate(359deg);
      }
    }

    .circle {
      position: absolute;
      top: -35px;
      left: 300px;

      width: 500px;
      height: 500px;

      // animation: ;

      animation: circle-ani 2s, rotate 1.5s linear 1.5s infinite;
    }

    @keyframes title-ani {
      from {
        right: -1100px;
      }

      to {
        right: 392px;
      }
    }

    .title {
      position: absolute;
      top: 183px;
      right: 392px;
      width: 310px;
      height: 63px;
      // visibility: hidden;

      animation: title-ani 2.5s linear;
    }

    @keyframes wine-ani {
      from {
        left: -35px;
      }

      to {
        left: 533px;
      }
    }

    .wine {
      position: absolute;
      top: 298px;
      left: 466.5px;
      width: 167px;
      /*height: 137px;*/

      /*animation: wine-ani 2s linear;*/
    }

    .tip {
      position: absolute;
      top: 459px;
      left: 400px;
      width: 300px;
      height: 22px;
      font-size: 20px;
      font-family: "FZQKBYSJW";
      font-weight: normal;
      color: rgba(228, 200, 150, 1);
      line-height: 22px;
    }
  }

  .step2 {
    @keyframes title-ani {
      from {
        right: -224px;
      }

      to {
        right: 435px;
      }
    }

    .title {
      position: absolute;
      top: 34px;
      right: 435px;
      width: 224px;
      height: 63px;

      animation: title-ani 0.5s linear;
    }

    @keyframes left-ani {
      from {
        left: 492px;
        opacity: 0;
      }

      to {
        left: 255px;
        opacity: 1;
      }
    }

    .left {
      position: absolute;
      top: 99px;
      left: 255px;
      width: 116px;
      height: 398px;

      animation: left-ani 0.5s linear;
    }

    @keyframes hu__hu__ {
      50% {
        transform: translateY(20px);
      }
    }

    @keyframes sprite-ani {
      from {
        opacity: 0;
      }

      to {
        opacity: 1;
      }
    }

    .sprite {
      position: absolute;
      top: 41px;
      left: 313px;
      width: 474px;
      height: 478px;

      animation: hu__hu__ infinite 2s ease-in-out, sprite-ani 0.5s;
    }

    @keyframes right-ani {
      from {
        left: 492px;
        opacity: 0;
      }

      to {
        left: 729px;
        opacity: 1;
      }
    }

    .right {
      position: absolute;
      top: 99px;
      left: 729px;
      width: 116px;
      height: 398px;

      animation: right-ani 0.5s linear;
    }
  }

  .step3 {
    @keyframes dialogmove {
      from {
        left: -480px;
      }

      to {
        left: 199px;
      }
    }
    .dialog {
      position: absolute;
      top: 127px;
      left: 199px;
      width: 480px;
      height: 223px;

      background-image: url("/images/game/dialog-right.png");
      background-size: cover;

      animation: dialogmove 3s linear;
      .content {
        padding: 50px;
        font-size: 18px;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 41px;
      }
    }

    @keyframes sprite-ani {
      from {
        right: -474px;
      }

      to {
        right: -33px;
      }
    }

    .sprite {
      position: absolute;
      top: 0px;
      right: -33px;
      width: 474px;
      height: 478px;

      animation: sprite-ani 1.5s linear;
    }
  }

  .step4 {
    .dialog {
      position: absolute;
      top: 49px;
      left: 322px;
      width: 534px;
      height: 101px;

      background-image: url("/images/game/dialog-left.png");
      background-size: cover;
      .content {
        padding: 20px 40px;
        font-size: 18px;
        font-weight: 400;
        color: rgba(0, 0, 0, 1);
        line-height: 34px;
      }
    }

    @keyframes spritemove {
      from {
        left: -474px;
      }

      to {
        left: -40px;
      }
    }

    .sprite {
      position: absolute;
      top: 0px;
      left: -40px;
      width: 474px;
      height: 478px;

      animation: spritemove 1.5s;
    }

    @keyframes cardmove {
      from {
        right: -825px;
      }

      to {
        right: 114px;
      }
    }

    .card-parent {
      position: absolute;
      top: 173px;
      right: 114px;
      width: 825px;
      height: 290px;
      background-image: url("/images/game/card-background.png");
      background-size: cover;

      animation: cardmove 1.5s linear;

      text-align: center;

      .tip1 {
        margin: 20px auto;
        height: 22px;
        font-size: 16px;
        font-weight: 600;
        color: rgba(255, 255, 255, 1);
        line-height: 22px;
      }
      .card {
        width: 280px;
        height: 156px;
      }
      .tip2 {
        margin: 20px auto;
        height: 20px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(255, 255, 255, 1);
        line-height: 20px;
        opacity: 0.5;
      }
    }
  }
}
</style>